import template from 'lodash/template';

import domains from '../containers/Domains';
import { getLocalStorageDataOrFetch } from './fbCallManager';

import { pageIds as nuPageIds } from './../constants/nissan-united';

const endpoint = domains.fbEndpoint;

const getPages = async (token, skipCache = false, userGroup) => {
  const parameters = {
    access_token: token,
    limit: 50
  };

  const query = template(
    `${endpoint}me/accounts?limit=<%= limit%>&access_token=<%= access_token%>`
  );
  const jsonResult = await getLocalStorageDataOrFetch(
    query(parameters),
    skipCache
  );

  const pages = jsonResult ? jsonResult.data : [];
  let finalPages = pages;

  // switch case leaves room for expansion to other clients in the future
  switch (userGroup) {
    case 'NU':
      finalPages = pages.filter((pageObj) =>
        nuPageIds.includes(`${pageObj.id}`)
      );
      break;
    default:
      break;
  }

  return { ...jsonResult, data: finalPages };
};

export { getPages as default };



// WEBPACK FOOTER //
// ./src/fbApi/User.js